import React from "react";
import { motion } from "framer-motion";
import {
  Footprints, MapPinned, ShoppingBag, CalendarRange, Languages, BadgeCheck,
  Landmark, Map as MapIcon, Hotel, UtensilsCrossed, Croissant, Flame, FerrisWheel, Mountain, Plane, Users, Store, Tent,
} from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { SectionHead } from "@/components/landing/Section";

const WHY_ICONS = [Footprints, MapPinned, ShoppingBag, CalendarRange, Languages, BadgeCheck];
const FOR_ICONS = [Landmark, MapIcon, Hotel, UtensilsCrossed, Croissant, Flame, FerrisWheel, Mountain, Plane, Users, Store, Tent];

export const Benefits = () => {
  const { t } = useLang();
  const s = t.pages.supporter;
  return (
    <section data-testid="supporter-benefits">
      <SectionHead kicker={s.whyKicker} title={s.whyTitle} />
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {s.why.map((w, i) => {
          const Icon = WHY_ICONS[i];
          return (
            <motion.div
              key={w.h}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
              data-testid={`supporter-benefit-${i}`}
              className="journal-card p-7 group transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-journal-lg"
            >
              <span className="w-12 h-12 rounded-2xl bg-moss/10 grid place-items-center transition-colors duration-300 group-hover:bg-moss">
                <Icon className="w-6 h-6 text-moss transition-colors duration-300 group-hover:text-parchment" />
              </span>
              <h3 className="mt-5 font-display text-xl font-semibold text-ink">{w.h}</h3>
              <p className="mt-2 text-ink-muted leading-relaxed">{w.p}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export const Audience = () => {
  const { t } = useLang();
  const s = t.pages.supporter;
  return (
    <section data-testid="supporter-audience" className="grid lg:grid-cols-12 gap-10 items-start">
      <SectionHead kicker={s.forKicker} title={s.forTitle} className="lg:col-span-4" />
      <ul className="lg:col-span-8 flex flex-wrap gap-3">
        {s.forList.map((item, i) => {
          const Icon = FOR_ICONS[i];
          return (
            <li key={item} className="inline-flex items-center gap-2.5 rounded-full border border-line bg-parchment px-5 py-3 font-bold text-ink transition-colors hover:border-moss hover:text-moss">
              <Icon className="w-4 h-4 text-amber" />
              {item}
            </li>
          );
        })}
      </ul>
    </section>
  );
};
